import CustomIcon from '../components/common/CustomIcon';
import React from 'react';
import { I18n, Translate } from 'react-redux-i18n-lite';

export const getVisibilityItem = (visibilityText, visibilityIcon, clickAction, disabled) => ({
  key: 1,
  text: visibilityText,
  onClick: clickAction,
  icon: visibilityIcon,
  disabled: !disabled
});

export const getNewVisibilityItem = (visibilityText, visibilityIcon, clickAction) => ({
  key: 1,
  text: visibilityText,
  icon: visibilityIcon,
  onClick: clickAction
});

export const getDeleteItem = (clickAction, disabled) => ({
  key: 2,
  text: I18n.t('common.option.delete'),
  onClick: clickAction,
  icon: 'custom-icons-waste-can',
  danger: true,
  disabled: !disabled
});

export const getNewDeleteItem = clickAction => ({
  key: 2,
  text: I18n.t('common.option.delete'),
  icon: 'custom-icons-waste-can',
  danger: true,
  onClick: clickAction
});

export const getEditItem = (clickAction, disabled) => ({
  key: 3,
  text: I18n.t('common.option.edit'),
  onClick: clickAction,
  icon: 'custom-icons-edit-pencil',
  disabled: !disabled
});

export const getCopyItem = (clickAction, disabled) => ({
  key: 4,
  text: I18n.t('common.option.copy'),
  onClick: clickAction,
  icon: 'custom-icons-copy-file',
  disabled: !disabled
});

export const getNewCopyItem = clickAction => ({
  key: 4,
  text: I18n.t('common.option.copy'),
  icon: 'custom-icons-copy-file',
  onClick: clickAction
});

export const getAssignItem = (clickAction, disabled) => ({
  key: 5,
  text: I18n.t('rightPanel.assign'),
  onClick: clickAction,
  icon: 'custom-icons-assign',
  disabled: !disabled
});

export const getCreateTaskItem = (clickAction, disabled) => ({
  key: 6,
  text: I18n.t('common.option.createTask'),
  onClick: clickAction,
  icon: 'custom-icons-workspace',
  disabled: !disabled
});

export const getNewUnitDrawer = (clickAction, disabled) => ({
  key: 7,
  text: I18n.t('common.option.createUnit'),
  onClick: clickAction,
  icon: 'custom-icons-plus-button',
  disabled: !disabled
});

export const seeGradesItem = (clickAction, disabled) => ({
  key: 8,
  text: I18n.t('common.option.seeGradebook'),
  onClick: clickAction,
  icon: 'custom-icons-gradebook',
  nav: true,
  disabled: !disabled
});

export const shareInGoogleClassroom = (clickAction, disabled) => ({
  key: 9,
  text: <Translate value="common.option.shareInGoogleClassroom" dangerousHTML />,
  onClick: clickAction,
  icon: 'custom-icons-google-plus-social-network-logo',
  disabled: !disabled
});

export const seeResourcesPreview = (clickAction, disabled) => ({
  key: 11,
  text: <Translate value="common.option.seeResourcesPreview" dangerousHTML />,
  onClick: clickAction,
  icon: 'custom-icons-school-paper-clip',
  disabled: !disabled
});

export const seeTaksItem = (clickAction, disabled) => ({
  key: 12,
  text: I18n.t('common.option.seeTaks'),
  onClick: clickAction,
  icon: 'custom-icons-office-monthly-calendar',
  nav: true,
  disabled: !disabled
});

export const getNeaeAdaptationsItem = (clickAction, disabled) => ({
  key: 13,
  text: I18n.t('common.option.neaeAdaptations'),
  onClick: clickAction,
  icon: 'custom-icons-pirate-treasure-map',
  disabled: !disabled
});

export const seeAnnotationsItem = (clickAction, disabled) => ({
  key: 14,
  text: I18n.t('leftMenu.annotations'),
  onClick: clickAction,
  icon: 'custom-icons-writing-notepad',
  nav: true,
  disabled: !disabled
});

export const seeDiscussionsItem = (clickAction, disabled) => ({
  key: 15,
  text: I18n.t('mobileSheets.seeDiscussions'),
  onClick: clickAction,
  icon: 'custom-icons-chat-speech-balloon',
  nav: true,
  disabled: !disabled
});
